import React, { useEffect, useState } from "react";
import { KeyboardButton, KeyboardContainer } from "./styles";

interface KeyboardProps {
	onKeyPress: (value: string) => void;
	onConfirm: (passwords: string[]) => void;
	updateClickedValues: (values: string[]) => void;
	updateParentInput: (value: string) => void;
}

const KeyboardPressPasswordEletronic: React.FC<KeyboardProps> = ({
	onKeyPress,
	onConfirm,
	updateParentInput,
	updateClickedValues,
}) => {
	const backspaceValue = "⬅";

	const buttonValues = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "0"];

	const [clickedValues, setClickedValues] = useState<string[]>([]);

	useEffect(() => {
		updateClickedValues(clickedValues);
		updateParentInput(clickedValues.join(""));

		if (clickedValues.length === 8) {
			onConfirm(clickedValues);
			setClickedValues([]);
		}
	}, [clickedValues, updateClickedValues, updateParentInput, onConfirm]);

	const handleKeyPress = (value: string) => {
		if (value === backspaceValue) {
			setClickedValues((prev) => prev.slice(0, -1));
		} else if (clickedValues.length < 8) {
			setClickedValues((prev) => [...prev, value]);
			onKeyPress(value);
		}
	};

	return (
		<KeyboardContainer>
			{buttonValues.map((value) => (
				<KeyboardButton key={value} onClick={() => handleKeyPress(value)}>
					{value}
				</KeyboardButton>
			))}

			<KeyboardButton onClick={() => handleKeyPress(backspaceValue)}>
				{backspaceValue}
			</KeyboardButton>
		</KeyboardContainer>
	);
};

export default KeyboardPressPasswordEletronic;
